export default "__VITE_ASSET__3771b606__"